import React from 'react'
import { Paper } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import { injectIntl } from 'react-intl'
import messages from './translate'

function PewForecast(props) {
  const {
    intl: { formatMessage },
    children,
  } = props

  return (
    <Grid item lg={8} md={7} sm={12} xs={12}>
      <Paper className="chart-wrap">
        <div className="wrap-header">
          <div className="title">{`12 ${formatMessage(
            messages.hourForecast,
          )}`}</div>
        </div>
        <div className="wrap-content">{children}</div>
      </Paper>
    </Grid>
  )
}

export default injectIntl(PewForecast)
